import { render, staticRenderFns } from "./CustomerPlaylist.vue?vue&type=template&id=544d52fc"
import script from "./CustomerPlaylist.vue?vue&type=script&lang=ts"
export * from "./CustomerPlaylist.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports